import React, {useState} from "react"
import { connect, ConnectedProps } from "react-redux"
import Select from "react-select"
import { getAction } from "../../../state/actionlog/actionLogSelector"
import { SelectOption } from "../../../state/helpers/SelectOption"
import InlineGenericEditComponent from "./InlineGenericEditComponent"


type OwnProps = {
    title: string
    name: string
    id: string
    value: SelectOption

    options: SelectOption[]
    onChange: (option: SelectOption, actionId: string) => void
    isMulti?: boolean
    isClearable?: boolean
}
const InlineSelectComponent = (props: Props) => {
    const [selected, setSelected] = useState<SelectOption>(props.value)

    return (
        <>
            <InlineGenericEditComponent
                valueObject={
                    <label>{props.title}</label>
                }
                inputObject={
                    <Select                 
                        name={props.name}
                        id={props.id}
                        value={selected}
                        options={props.options}
                        onChange={setSelected}
                        multi={props.isMulti || false}
                        clearable={props.isClearable || false}
                    />
                }
                action={props.action}
                onSave={() => props.onChange(selected, props.id) }
                popupStyle={{ minWidth: "350px" }}
            />
        </>
    )
}

const mapState = (state, props: OwnProps) => {
    const action = getAction(state, props.id)
    return { ...props, action: action}
}
const connector = connect(mapState, {})
type Props = ConnectedProps<typeof connector>

export default connector(InlineSelectComponent)


// WEBPACK FOOTER //
// ./src/common/inline-edit/component/InlineSelectComponent.tsx